import { Card, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import { opsCategoryTotal, opsServicesTotal, useOpsSummary } from '@/api/operations';

/**
 * Operations stat band — always-on system-wide counts from `/internal/ops/summary`.
 * Displays: Total services · CDN · WAAP · Compute · Active orgs · Total domains.
 * Per spec: banner is always visible and reflects the full system state, not the
 * user's current filter/search.
 */
export function OpsStatBand() {
  const { data, isLoading } = useOpsSummary();

  const stats = [
    {
      label: 'Total services',
      value: opsServicesTotal(data),
      dotColor: 'var(--vn-primary-solid)',
    },
    {
      label: 'CDN',
      value: opsCategoryTotal(data, 'cdn'),
      dotColor: 'var(--vn-info-solid)',
    },
    {
      label: 'WAAP',
      value: opsCategoryTotal(data, 'waap'),
      dotColor: 'var(--vn-warning-solid)',
    },
    {
      label: 'Compute',
      value: opsCategoryTotal(data, 'compute'),
      dotColor: 'var(--vn-success-solid)',
    },
    {
      label: 'Active orgs',
      value: data?.distinct_orgs ?? 0,
      dotColor: 'var(--vn-primary-solid)',
    },
    {
      label: 'Total domains',
      value: data?.total_domains ?? 0,
      dotColor: 'var(--vn-info-solid)',
    },
  ];

  return (
    <Card flat>
      <CardBody>
        {isLoading ? (
          <StatGroup columns={6}>
            {stats.map((s) => (
              <Skeleton key={s.label} style={{ height: 56 }} />
            ))}
          </StatGroup>
        ) : (
          <StatGroup columns={6}>
            {stats.map((s) => (
              <Stat
                key={s.label}
                label={s.label}
                dotColor={s.dotColor}
                value={s.value.toLocaleString('en-US')}
              />
            ))}
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
